import React from 'react';
import { SignIn } from '@clerk/clerk-react';

function Login() {
  return (
    <div style={{
      backgroundColor: '#0a0e1a',
      minHeight: '100vh',
      padding: '60px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }}>
      <SignIn
        routing="path"
        path="/login"
        signUpUrl="/signup"
        appearance={{
          variables: {
            colorBackground: '#1a1f2e',
            colorText: '#ffffff',
            colorTextSecondary: '#a0aec0',
            colorPrimary: '#00d9ff',
            colorNeutral: '#a0aec0'
          },
          elements: {
            rootBox: { width: '100%', maxWidth: '440px' },
            card: {
              backgroundColor: '#1a1f2e',
              border: '1px solid #2d3748',
              borderRadius: '12px',
              boxShadow: 'none'
            },
            footer: { backgroundColor: '#1a1f2e', borderTop: '1px solid #2d3748' },
            footerPages: { backgroundColor: '#1a1f2e' },
            footerPagesLink: { color: '#64748b' },
            internal: { backgroundColor: '#1a1f2e' },
            headerTitle: { color: '#ffffff' },
            headerSubtitle: { color: '#a0aec0' },
            formFieldLabel: { color: '#a0aec0' },
            formFieldInput: {
              backgroundColor: '#0f1419',
              border: '1px solid #2d3748',
              color: '#ffffff',
              borderRadius: '8px'
            },
            formButtonPrimary: {
              backgroundColor: '#00d9ff',
              color: '#0a0e1a',
              fontWeight: '700',
              borderRadius: '8px'
            },
            footerActionLink: { color: '#00d9ff' },
            identityPreviewEditButton: { color: '#00d9ff' },
            formFieldInputShowPasswordButton: { color: '#a0aec0' },
            otpCodeFieldInput: {
              backgroundColor: '#0f1419',
              border: '1px solid #2d3748',
              color: '#ffffff',
              borderRadius: '8px'
            },
            formResendCodeLink: { color: '#00d9ff' },
            alternativeMethodsBlockButton: { color: '#a0aec0', borderColor: '#2d3748' },
            alertText: { color: '#f59e0b' },
            alert: { backgroundColor: 'rgba(245, 158, 11, 0.1)', borderColor: 'rgba(245, 158, 11, 0.4)' }
          }
        }}
      />
    </div>
  );
}

export default Login;
